import type { DataSource } from "./DataSource";
import type { DataMode } from "./types";

/**
 * Loads only the source this page needs: the demo fixtures are never
 * downloaded in live mode, and live mode (Welthra V2) never runs in the demo.
 */
export async function loadDataSource(mode: DataMode): Promise<DataSource> {
  if (mode === "demo") {
    const { createDemoSource } = await import("./demo");
    return createDemoSource();
  }
  const { createWelthraSource } = await import("./welthra");
  return createWelthraSource();
}
